(() => {
  if (customElements.get('hihi-sell-dropdown')) return;
  customElements.define('hihi-sell-dropdown', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = {signal:this.cleanup.signal};
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      const close = () => {details.open = false;};
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded',String(details.open));
        if(details.open) this.closest('[data-resale-nav]')?.querySelector('[data-panel]')?.classList.remove('is-open');
      }, options);
      document.addEventListener('click',e=>{if(!this.contains(e.target)) close();},options);
      document.addEventListener('keydown',e=>{if(e.key==='Escape' && details.open){close();summary.focus();}},options);
      this.addEventListener('focusout',e=>{if(e.relatedTarget&&!this.contains(e.relatedTarget))close();},options);
      this.closest('[data-resale-nav]')?.querySelectorAll('[data-menu-key]').forEach(a=>a.addEventListener('mouseenter',close,options));
    }
    disconnectedCallback(){this.cleanup?.abort();}
  });
})();
